import React, { useContext, useEffect, useState } from "react";
import {
  Hidden,
  useMediaQuery,
  SwipeableDrawer,
  Button,
  List,
  ListItemText,
  Box,
  Paper,
  Divider,
  Stack,
  IconButton,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import clsx from "clsx";
import {
  navLogo,
  feedUnfill,
  pointsUnfill,
  feedFill,
  pointsFill,
  accountUnfill,
} from "./SmallComponents/Images";
import { CiTwitter } from "react-icons/ci";
import { SiGitbook } from "react-icons/si";
import { PiTelegramLogo } from "react-icons/pi";
import { FaMedium } from "react-icons/fa6";
import { fetchBalance } from "@wagmi/core";

import { StyledButton, toLocalFormat } from "./SmallComponents/AppComponents";
import { AppContext } from "../utils";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { Link, useLocation } from "react-router-dom";

const useStyles = makeStyles({
  list: {
    width: 260,
  },
  fullList: {
    width: "auto",
    alignItems: "center",
  },
  paper: {
    background: "#292929 !important",
    boxShadow: "0px 4px 6px 2px #ffffff !important",
  },
  hover: {
    "&:hover": {
      color: "#FFB800",
    },
  },
});
const socialArray = [
  {
    icon: (
      <CiTwitter
        style={{
          color: "#ffffff",
          fontSize: "20px",
        }}
      />
    ),
    link: "#",
  },
  {
    icon: (
      <PiTelegramLogo
        style={{
          color: "#ffffff",
          fontSize: "20px",
        }}
      />
    ),
    link: "#",
  },
  {
    icon: (
      <SiGitbook
        style={{
          color: "#ffffff",
          fontSize: "20px",
        }}
      />
    ),
    link: "#",
  },
  {
    icon: (
      <FaMedium
        style={{
          color: "#ffffff",
          fontSize: "20px",
        }}
      />
    ),
    link: "#",
  },
];

export const navArray = [
  {
    fillIcon: feedFill,
    unfillIcon: feedUnfill,
    text: "Feed",
    link: "/feeds",
  },
  {
    fillIcon: pointsFill,
    unfillIcon: pointsUnfill,
    text: "Points Details",
    link: "/points-details",
  },
  {
    fillIcon: pointsFill,
    unfillIcon: pointsUnfill,
    text: "Points Exchange",
    link: "/points-exchange",
  },
  {
    fillIcon: accountUnfill,
    unfillIcon: accountUnfill,
    text: "Account",
    link: "/",
  },
];

export default function Header() {
  const { pathname } = useLocation();

  const { open } = useWeb3Modal();
  const { account, chainId } = useContext(AppContext);
  const classes = useStyles();
  const [userBalance, setUserBalance] = useState(0);
  const [state, setState] = React.useState({
    left: false,
  });
  const matches1 = useMediaQuery("(max-width:1279px)");

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box display="flex" justifyContent="center" my={3}>
        {/* <Box component={"img"} width="150px" src={navLogo} alt="" />
         */}
        <Typography
          variant="h1"
          sx={{
            fontFamily: "Saira Semi Condensed",
            fontSize: { xs: "24px", md: "38px" },
            fontWeight: "700",
            color: "#ffffff",
          }}
        >
          BITGROK AI
        </Typography>
      </Box>
      <List>
        {navArray?.map(({ text, unfillIcon, fillIcon, link }) => (
          <Link key={text} to={link} style={{ textDecoration: "none" }}>
            <ListItemButton
              sx={{
                mb: 3,
              }}
            >
              <ListItemIcon>
                <Box
                  component={"img"}
                  alt=""
                  src={pathname === link ? fillIcon : unfillIcon}
                  width={"30px"}
                />
              </ListItemIcon>
              <ListItemText
                sx={{
                  textTransform: "capitalize",
                  textDecoration: "none",
                  cursor: "pointer",
                  color:
                    pathname === link
                      ? pathname === "/points-details"
                        ? "#8102FF"
                        : "#A229D4"
                      : "#ffffff",
                  ".MuiTypography-root": {
                    fontFamily: "Saira Semi Condensed",
                    fontSize: "20px",
                  },
                }}
                primary={text}
              />
            </ListItemButton>
          </Link>
        ))}
      </List>
      <Box mt={1} display="flex" justifyContent="center">
        <StyledButton px={2} onClick={async () => await open()}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {toLocalFormat(userBalance)} ETH
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                background: "#1F1F1F",
                width: "1px",
              }}
            />{" "}
            <span
              style={{
                fontWeight: "400",
              }}
            >
              {account
                ? account.slice(0, 4) + "..." + account.slice(-4)
                : "Connect"}
            </span>
          </Box>
        </StyledButton>
      </Box>
    </div>
  );

  useEffect(() => {
    if (account && chainId === 1) {
      (async () => {
        try {
          const balance = await fetchBalance({
            address: account,
          });
          const balanceInEth = Number(balance?.formatted);
          setUserBalance(parseFloat(balanceInEth)?.toFixed(2));
        } catch (e) {
          console.log(e);
        }
      })();
    }
  }, [account, chainId]);
  return (
    <>
      <Box
        sx={{
          background: "transparent",
        }}
        // height="92px"
        width="100%"
        py={1}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={{ xs: 2, md: 0 }}
        >
          <Hidden mdUp>
            {/* <Box component={"img"} width="100px" src={navLogo} alt="" /> */}

            <Typography
              variant="h1"
              sx={{
                fontFamily: "Saira Semi Condensed",
                fontSize: { xs: "18px", md: "38px" },
                fontWeight: "700",
                color: "#ffffff",
                flexBasis: "100%",
              }}
            >
              BITGROK AI
            </Typography>
          </Hidden>
          <Box
            display="flex"
            justifyContent={matches1 ? "end" : "space-between"}
            alignItems="center"
            width={"100%"}
          >
            <Hidden mdDown>
              <Stack
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  mx: 3,
                  my: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  {socialArray.map(({ icon, link }) => (
                    <IconButton key={icon}>{icon}</IconButton>
                  ))}
                </Box>
                <Box>
                  <StyledButton
                    px={2}
                    // width="260px"
                    onClick={async () => await open()}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {toLocalFormat(userBalance)} ETH
                      <Divider
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        sx={{
                          background: "#dedad9",
                          width: "1px",
                        }}
                      />{" "}
                      <span
                        style={{
                          fontWeight: "400",
                        }}
                      >
                        {account
                          ? account.slice(0, 4) + "..." + account.slice(-4)
                          : "Connect"}
                      </span>
                    </Box>
                  </StyledButton>
                </Box>
              </Stack>
            </Hidden>
            <Hidden mdUp>
              {["left"].map((anchor) => (
                <React.Fragment key={anchor}>
                  <Button
                    onClick={toggleDrawer(anchor, true)}
                    style={{ zIndex: 1 }}
                  >
                    <MenuIcon
                      style={{
                        fontSize: "38px",
                        cursor: "pointer",
                        color: "#ffffff",
                      }}
                    />
                  </Button>
                  <Paper>
                    <SwipeableDrawer
                      classes={{ paper: classes.paper }}
                      sx={{
                        boxShadow: "13px -5px 5px -9px #ffffff",
                      }}
                      anchor={anchor}
                      open={state[anchor]}
                      onClose={toggleDrawer(anchor, false)}
                      onOpen={toggleDrawer(anchor, true)}
                    >
                      {list(anchor)}
                    </SwipeableDrawer>
                  </Paper>
                </React.Fragment>
              ))}
            </Hidden>
          </Box>
        </Box>
      </Box>
    </>
  );
}
